import { BLOCK_REGISTRY } from "../blockRegistry";

const CHECKOUT_DEFAULT_BLOCKS = [
  { id: "default-checkout-footnotes", type: "checkout-footnotes" },
].map((block) => ({
  ...block,
  fields: BLOCK_REGISTRY[block.type].defaultFields,
}));

export default CHECKOUT_DEFAULT_BLOCKS;
